import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { ApolloError } from '@apollo/client/core';
import { ValidationError } from '@ngx-pwa/local-storage';
import { Message } from 'primeng/api';

export interface ErrorWithMessage {
  message: string;
  detail?: string;
}

@Component({
  selector: 'vnm-validation-errors',
  templateUrl: './validation-errors.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ValidationErrorsComponent {
  @HostBinding('style.display') get isHidden() {
    return this.messages?.length ? 'flex' : 'none';
  }
  messages: Message[];

  @Input() set errors(errors: ValidationError[] | ApolloError | ErrorWithMessage[]) {
    if (errors) {
      let values: ReadonlyArray<ErrorWithMessage>;
      if ('graphQLErrors' in errors) {
        const { graphQLErrors } = errors as ApolloError;
        values = graphQLErrors;
      } else {
        values = errors;
      }
      this.messages = values.map((error) => {
        const message: Message = {
          severity: 'error',
          summary: error.message,
          detail: error.detail
        };
        return message;
      });
    } else {
      this.messages = [];
    }
  }
}
